module.exports = __webpack_public_path__ + "img/fin-academy-manual.9ab78820.svg";